import React, { useState } from "react";
import Button from "../../components/ui/button";
import { processPaymentRefund } from "../../stores/services/dividend-announcement.service";

function SendPaymentModal({ data, body }: { data: any; body: any }) {
  const [isEditingBankAccount, setIsEditingBankAccount] = useState(false);
  const [processPaymentLoading, setProcessPaymentLoading] = useState(false);

  const [bankAccountDetails, setBankAccountDetails] = useState({
    accountNo: data.unitholder_account_no || "",
    accountTitle: data.unitholder_account_title || "",
    bank: data.unitholder_bank || "",
    branch: data.unitholder_bank_branch || "",
  });

  const handleEditClick = () => {
    setIsEditingBankAccount(true);
  };

  const handleSaveClick = () => {
    // Here you would typically send the updated bankAccountDetails to your backend
    setIsEditingBankAccount(false);
  };

  const handleCancelClick = () => {
    // Revert to original data or last saved data
    setBankAccountDetails({
      accountNo: data.unitholder_account_no || "",
      accountTitle: data.unitholder_account_title || "",
      bank: data.unitholder_bank || "",
      branch: data.unitholder_bank_branch || "",
    });
    setIsEditingBankAccount(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setBankAccountDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  return (
    <div className="modal-body">
      <div className="row">
        <div className="col-md-6">
          <div
            className="card mb-3"
            style={{ border: "1px solid rgba(118, 75, 162, 0.2)" }}
          >
            <div
              className="card-header"
              style={{ backgroundColor: "rgba(118, 75, 162, 0.1)" }}
            >
              <h6>
                <i className="fas fa-user me-2"></i>
                Divident Amount Payment Information
              </h6>
            </div>
            <div className="card-body">
              <div className="mb-2">
                <strong>Name:</strong>
                <span className="ms-2">{data.unitholder_name || "N/A"}</span>
              </div>
              <div className="mb-2">
                <strong>CNIC:</strong>
                <span className="ms-2">{data.unitholder_cnic || "N/A"}</span>
              </div>
              <div className="mb-2">
                <strong>Email:</strong>
                <span className="ms-2">{data.unitholder_email || "N/A"}</span>
              </div>
              <div className="mb-2">
                <strong>Mobile:</strong>
                <span className="ms-2">{data.unitholder_mobile || "N/A"}</span>
              </div>
              <div className="mb-2">
                <strong>Tax Status:</strong>
                <span className="ms-2 badge bg-secondary">
                  {data.unitholder_tax_status || "N/A"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div
            className="card mb-3"
            style={{ border: "1px solid rgba(118, 75, 162, 0.2)" }}
          >
            <div
              className="card-header"
              style={{ backgroundColor: "rgba(118, 75, 162, 0.1)" }}
            >
              <h6 className="d-flex justify-content-between align-items-center">
                <span>
                  <i className="fas fa-university me-2"></i>
                  Account Information
                </span>
                {!isEditingBankAccount && (
                  <button
                    onClick={handleEditClick}
                    className="btn btn-link p-0"
                    title="Update Bank Account Details"
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </button>
                )}
              </h6>
            </div>
            <div className="card-body">
              <div className="mb-2">
                <strong>Folio No:</strong>
                <span className="ms-2">{data.folio_no || "N/A"}</span>
              </div>

              {isEditingBankAccount ? (
                <>
                  <div className="mb-2">
                    <strong>Account No:</strong>
                    <input
                      type="text"
                      name="accountNo"
                      className="form-control ms-2"
                      value={bankAccountDetails.accountNo}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-2">
                    <strong>Account Title:</strong>
                    <input
                      type="text"
                      name="accountTitle"
                      className="form-control ms-2"
                      value={bankAccountDetails.accountTitle}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-2">
                    <strong>Bank:</strong>
                    <input
                      type="text"
                      name="bank"
                      className="form-control ms-2"
                      value={bankAccountDetails.bank}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-2">
                    <strong>Branch:</strong>
                    <input
                      type="text"
                      name="branch"
                      className="form-control ms-2"
                      value={bankAccountDetails.branch}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="d-flex justify-content-end mt-3">
                    <Button onClick={handleSaveClick}>Save</Button>
                    <button
                      onClick={handleCancelClick}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-2">
                    <strong>Account No:</strong>
                    <span className="ms-2">
                      {bankAccountDetails.accountNo || "N/A"}
                    </span>
                  </div>
                  <div className="mb-2">
                    <strong>Account Title:</strong>
                    <span className="ms-2">
                      {bankAccountDetails.accountTitle || "N/A"}
                    </span>
                  </div>
                  <div className="mb-2">
                    <strong>Bank:</strong>
                    <span className="ms-2">
                      {bankAccountDetails.bank || "N/A"}
                    </span>
                  </div>
                  <div className="mb-2">
                    <strong>Branch:</strong>
                    <span className="ms-2">
                      {bankAccountDetails.branch || "N/A"}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div
            className="card"
            style={{ border: "1px solid rgba(118, 75, 162, 0.2)" }}
          >
            <div
              className="card-header"
              style={{ backgroundColor: "rgba(118, 75, 162, 0.1)" }}
            >
              <h6>
                <i className="fas fa-chart-line mx-2"></i>
                Dividend Information
              </h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-2">
                    <strong>Holdings:</strong>
                    <div className="text-primary fs-5">
                      {data.unitholder_holding_for_dividend || 0}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-2">
                    <strong>Dividend Per Unit:</strong>
                    <div className="text-success fs-5">
                      {data.dividend_per_unit || 0}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-2">
                    <strong>Gross Dividend:</strong>
                    <div className="text-info fs-5">
                      {data.gross_dividend || 0}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-2">
                    <strong>Net Dividend:</strong>
                    <div className="text-warning fs-5">
                      {data.net_dividend || 0}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <div
            className="card-header p-2 pb-0"
            style={{ backgroundColor: "rgba(118, 75, 162, 0.1)" }}
          >
            <h4>
              <i className="fas fa-money-bill-wave mx-3 text-success"></i>
              Refund of Capital Details
            </h4>
          </div>
          <div className="card-body border rounded text-center">
            <div className="row justify-content-center">
              <div className="col-md-5">
                <strong className="d-block mb-1">Refund Amount:</strong>
                <div className="fw-bold display-6 mb-3">
                  PKR{" "}
                  {data.refund_of_capital
                    ? parseFloat(data.refund_of_capital).toLocaleString(
                      undefined,
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )
                    : "0.00"}
                </div>
              </div>
              <div className="col-md-5">
                <strong className="d-block mb-1">Purchase NAV:</strong>
                <div className="fs-3">
                  PKR{" "}
                  {data.refund_purchase_nav
                    ? parseFloat(data.refund_purchase_nav).toLocaleString(
                      undefined,
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )
                    : "0.00"}
                </div>
              </div>
            </div>
            <Button
              size="sm"
              onClick={async () => {
                try {
                  setProcessPaymentLoading(true);
                  await processPaymentRefund(body);
                  setProcessPaymentLoading(false);
                } catch (error) {
                  setProcessPaymentLoading(false);
                }
              }}
              disabled={processPaymentLoading}
            >
              <span>
                {processPaymentLoading ? "Sending...." : "Send Payment"}
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SendPaymentModal;
